// Status labels, loan program data, helpers

export const LOAN_PROGRAMS = [
  { key: "fix_and_flip", name: "Fix & Flip", rate: "9.25%", tagline: "Up to 90% LTV, close in 7-10 days, 100% rehab financing." },
  { key: "dscr", name: "DSCR Rental", rate: "5.75%", tagline: "No W-2 or tax returns. Qualifies on rental income." },
  { key: "bridge", name: "Bridge Loans", rate: "8.50%", tagline: "Short-term gap financing, 6-24 months." },
  { key: "construction", name: "Ground-Up Construction", rate: "10.50%", tagline: "Up to 85% LTC for ground-up builds." },
  { key: "multifamily", name: "Multifamily (5+ units)", rate: "6.50%", tagline: "Acquisition & refinance for small- and mid-multifamily." },
  { key: "cash_out_refi", name: "Cash-Out Refinance", rate: "7.50%", tagline: "Unlock equity from existing investment properties." },
  { key: "commercial", name: "Commercial & Mixed-Use", rate: "8.00%", tagline: "Retail, office, industrial, mixed-use." },
  { key: "portfolio", name: "Rental Portfolio", rate: "6.75%", tagline: "Blanket loans covering multiple properties." },
];

export const APPLICATION_STATUSES = {
  intake_submitted: { label: "Intake Submitted", className: "bg-blue-50 text-blue-700 border-blue-200" },
  sponsor_review: { label: "Broker Review", className: "bg-slate-100 text-slate-700 border-slate-200" },
  submitted_to_admin: { label: "Submitted to Admin", className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  ok_to_apply: { label: "OK to Apply", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  docs_requested: { label: "Docs Requested", className: "bg-amber-50 text-amber-700 border-amber-200" },
  application_sent: { label: "Application Sent", className: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  under_review: { label: "Under Review", className: "bg-violet-50 text-violet-700 border-violet-200" },
  approved: { label: "Approved", className: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  denied: { label: "Denied", className: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const LEAD_STAGES = [
  { key: "new", label: "New" },
  { key: "contacted", label: "Contacted" },
  { key: "interested", label: "Interested" },
  { key: "follow_up", label: "Follow Up" },
  { key: "not_interested", label: "Not Interested" },
  { key: "converted", label: "Converted" },
];

export const LOAN_TYPE_LABELS = Object.fromEntries(
  LOAN_PROGRAMS.map((p) => [p.key, p.name])
);

export function fmtCurrency(n) {
  if (n == null || n === "") return "$0";
  const num = Number(n);
  if (!isFinite(num)) return "$0";
  return num.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}
